<template>
    <!DOCTYPE html><html>
      <head></head>
        <body style="font-family: 'Montserrat', sans-serif; color: #000000 !important;">
          <pre v-if="linea === 1" style="margin-top: 0px; margin-bottom: 0px; font-family: 'Montserrat', sans-serif; font-size: 36px; font-weight:800; text-align: center; text-transform: uppercase;">'Autobuses a otro nivel'</pre>
          <pre v-else style="margin-top: 0px; margin-bottom: 0px; font-family: 'Montserrat', sans-serif; font-size: 36px; font-weight:800; text-align: center; text-transform: uppercase;">'Comodidad a tu alcance'</pre>
          <pre style="margin-top: 0px; margin-bottom: 0px; font-family: 'Montserrat', sans-serif; font-size: 21px; font-weight:600; text-align: center;">Manten abrochado tu cinturón de seguridad durante el viaje</pre>
          <pre style="margin-top: 0px; margin-bottom: 10px; font-family: 'Montserrat', sans-serif; font-size: 40px; font-weight:900; text-align: center; text-transform: uppercase;">Pase de Abordar</pre>
          <!--<span style="margin: 2px; font-size: 18px;">{{user.agencia_activa +' - '+ user.username +' -'}} <span>{{ boleto.created_at | moment('DD-MM-YYYY HH:mm') }}</span></span> -->
          <table style="border-collapse: collapse; width: 100%; font-size: 28px; text-align: left;">  
            <tr>    
              <td style="padding-right: 2px; font-weight:600;">Folio</td>
              <td style="padding-right: 2px; font-weight:600;">No de Pase</td>  
            </tr>  
            <tr>    
              <td style="padding-right: 2px; text-transform: uppercase; font-weight:800;">{{boleto.clave_facturacion}}</td>
              <td style="padding-right: 2px; text-transform: uppercase; font-weight:800;">{{boleto.id}}</td>  
            </tr>  
            <tr> 
              <td style="padding-right: 2px; margin-top: 8px; font-weight:600;">Nombre pasajero</td>
              <td style="padding-right: 2px; margin-top: 8px; font-weight:600;">Tipo de pasajero</td>   
            </tr>    
            <tr>    
              <td style="padding-right: 2px; text-transform: uppercase; font-weight:800;">{{boleto.nombre_pasajero}}</td>
              <td v-if="boleto.descuento != undefined && boleto.descuento != null && boleto.descuento.valor != 0" style="padding-right: 2px; text-transform: uppercase; font-weight:800;">
                <span>{{ boleto.descuento.nombre }}</span>
              </td>
              <td v-else style="padding-right: 2px; text-transform: uppercase; font-weight:800;">
                <span>Adulto</span>
              </td>      
            </tr>  
            <tr>    
              <td style="padding-right: 2px; margin-top: 8px; font-weight:600;">Origen</td>
              <td style="padding-right: 2px; margin-top: 8px; font-weight:600;">Asiento</td>   
            </tr>
            <tr>    
              <td style="padding-right: 2px; text-transform: uppercase; font-weight:800;">{{boleto.terminal_origen}}</td>
              <td style="padding-right: 2px; text-transform: uppercase; font-weight:800;">{{boleto.asiento}}</td>  
            </tr> 
            <tr>    
              <td style="padding-right: 2px; margin-top: 8px; font-weight:600;">Destino</td>
              <td style="padding-right: 2px; margin-top: 8px; font-weight:600;">Tipo de servicio</td>   
            </tr>
            <tr>    
              <td style="padding-right: 2px; text-transform: uppercase; font-weight:800;">{{boleto.terminal_destino}}</td>
              <td style="padding-right: 2px; text-transform: uppercase; font-weight:800;">
                <span v-if="(boleto.asiento === null)">Blanco</span>
                <span v-else>
                  <span v-if="(boleto.categoria_asiento_id === 1)">Básica</span>
                  <span v-if="(boleto.categoria_asiento_id === 2)">Ejecutiva</span>
                  <span v-if="(boleto.categoria_asiento_id === 3)">Confort</span>
                </span>
              </td>  
            </tr>
            <tr>    
              <td style="padding-right: 2px; margin-top: 8px; font-weight:600;">Fecha de viaje</td>
              <td style="padding-right: 2px; margin-top: 8px; font-weight:600;">Hora de viaje</td>   
            </tr>
            <tr>    
              <td style="padding-right: 2px; text-transform: uppercase; font-weight:800;">{{boleto.fecha_salida | horaFija('dddd, DD/MM/YYYY')}}</td>
              <td style="padding-right: 2px; text-transform: uppercase; font-weight:800;">{{boleto.fecha_salida | horaFija('HH:mm')}} Hrs</td>  
            </tr> 
            <tr>    
              <td style="padding-right: 1px; margin-top: 8px; font-weight:600;">Forma de pago</td>
              <td style="padding-right: 1px; margin-top: 8px; font-weight:600;">Tipo de venta</td>
            </tr>
            <tr>    
              <td style="padding-right: 2px; text-transform: uppercase; font-weight:800;">{{ boleto.metodo }}</td>
              <td style="padding-right: 2px; text-transform: uppercase; font-weight:800;">{{ boleto.lugar_emision }}</td>   
            </tr> 
            <tr>    
              <td style="padding-right: 1px; margin-top: 8px; font-weight:600;">Importe total</td>   
            </tr>
            <tr>    
              <td style="padding-right: 2px; text-transform: uppercase; font-weight:800;">${{ boleto.monto_total_pagar }}</td>  
            </tr> 
          </table>
          <pre style="margin-top: 4px; font-family: 'Montserrat', sans-serif; font-size: 18px; font-weight:600; text-align: center; text-transform: uppercase;">Para facturar, conoce el aviso de privacidad y nuestras políticas comerciales en www.platinumline.mx</pre>
        </body>
      </html>
</template>
<script>
export default { 
  props: {
    boleto: {required: false},
    user: {required: false},
    linea: {required: false},
  },

  mounted(){
  },

  data() {
      return {
       
      };
    },
}
</script>